<template>
  <div class="moneyincategory">
    <el-divider content-position="left">收款方式列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.category_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button
          type="warning"
          size="small"
          @click.native="$router.push('classify_collection')"
          >新增分类</el-button
        >
        <el-button type="primary" size="small" @click="categoryIn">录入</el-button>
        <el-button
          type="primary"
          size="small"
          @click.native="$router.push('setting_panel')"
          >返回上一级</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="名称" prop="category_name">
            <el-input v-model="categoryForm.category_name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="所属分类" prop="classify">
            <el-select v-model="categoryForm.classify" placeholder="选择所属分类" size="mini">
              <el-option v-for="(item, index) in parentCates" :key="index" :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="categoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="名称" prop="category_name">
            <el-input v-model="editCategoryForm.category_name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="所属分类" prop="classify">
            <el-select v-model="editCategoryForm.classify" placeholder="选择所属分类" size="mini">
              <el-option v-for="(item, index) in parentCates" :key="index" :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="ifDisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      height="calc(100vh - 280px)"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="category_name" label="名称"> </el-table-column>
      <el-table-column label="所属分类">
        <template slot-scope="scope"> 
          <span>{{ scope.row.classify !== null ? scope.row.classify.name : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadio(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoneyInCategory",
  data() {
    return {
      searchArr: {
        category_id: "",
      },
      npage: 1,
      categoryPerPage: 30,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: "rtl",
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      parentCates: [],
      categoryForm: {
        categoryId: "",
        category_name: "",
        classify: "",
        display: false,
      },
      editCategoryForm: {
        categoryId: "",
        category_name: "",
        classify: "",
        display: false,
      }
    };
  },
  mounted() {
    this.loadTable();
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    loadTable() {
      this.$axios
        .get("api/moneyin/index", {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searcher,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data;
            this.parentCates = data.parentCates;
            this.total = data.data.total;
            this.loadRadio();
            this.loadSort();
          }
        })
        .catch();
    },
    loadRadio() {
      this.categoryData.map((item) => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false;
        } else {
          this.ListIfDisplay[item.id] = true;
        }
      });
    },
    loadSort() {
      this.categoryData.map((item) => {
        this.listSort[item.id] = Number(item.sort);
      });
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
    handleSizeChange(val) {
      this.categoryPerPage = val;
      this.loadTable();
    },
    editRow(index, row) {
      this.editCategoryForm.categoryId = row.id;
      this.editCategoryForm.category_name = row.category_name;
      this.editCategoryForm.classify = row.classify ? row.classify.id : '';
      this.editCategoryForm.display = row.display === 1 ? false : true;
      this.categoryEditDrawer = true;
    },
    searchRemoteCfcategory(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(query);
        }, 200);
      } else {
        this.searchCategories = [];
      }
    },
    searchItem(query) {
      this.$axios
        .get("api/moneyin/getitem", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data;
          }
        })
        .catch();
    },
    handleSearchCfcategory(query) {
      this.searcher = query;
      setTimeout(() => {
        this.loadTable();
      });
    },
    categoryIn() {
      this.categoryIndrawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          if (this.$refs["categoryForm"]) {
            this.$refs["categoryForm"].resetFields();
          }
          if (this.$refs["editCategoryForm"]) {
            this.$refs["editCategoryForm"].resetFields();
          }
          this.categoryEditDrawer = false;
          this.categoryIndrawer = false;
          done();
        })
        .catch((_) => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("api/moneyin/store", {
              category_name: this.categoryForm.category_name,
              display: this.categoryForm.display === false ? 1 : 0,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.$refs.categoryForm.resetFields();
                this.categoryIndrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .put("api/moneyin/edit", {
              id: this.editCategoryForm.categoryId,
              category_name: this.editCategoryForm.category_name,
              cate_id: this.editCategoryForm.classify,
              display: this.ifDisplay === false ? 1 : 0,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.categoryEditDrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editListRadio(row) {
      this.$axios
        .put("api/moneyin/listshow", {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    setSort(row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error("排序值为数字！");
        return false;
      }
      this.$axios
        .put("api/moneyin/setsort", {
          id: row.id,
          sort: this.listSort[row.id],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
  },
};
</script>

<style scoped>
.moneyincategory {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 15px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/MoneyInCategory.vue